import { createStore } from 'react-contextual'
import { isMobile } from '../helpers/viewPortHelper'

export default createStore({
  focusedItem: null,
  menuToggled: false,
  keyboardActivated: false,
  activeMenu: 0,
  previousMenu: 0,
  activeCategory: {
    index: null,
    title: null,
    link: null,
  },
  activeDrillDownCategory: {
    title: null,
    link: null,
    links: null,
  },
  activeDrillDownLevelTwoCategory: {
    title: null,
    links: null,
  },
  onUpdateFocusedItem: (focusedItem) => ({ focusedItem }),
  onUpdateActiveMenu: (activeMenu) => ({ activeMenu }),
  onUpdatePreviousMenu: (previousMenu) => ({ previousMenu }),
  onUpdateActiveCategory: (activeCategory) => ({ activeCategory }),
  onUpdateActiveDrillDownCategory: (activeDrillDownCategory) => ({ activeDrillDownCategory }),
  onUpdateActiveDrillDownLevelTwoCategory: (activeDrillDownLevelTwoCategory) => ({ activeDrillDownLevelTwoCategory }),
  onSetKeyboardActivated: (keyboardActivated) => ({ keyboardActivated }),
  onToggleMenu: (evt, menuToggled, onUpdateActiveMenu) => {
    if (evt) evt.preventDefault()
    if (menuToggled) {
      // On mobile, open at level 0 (e.g. for Shop at Argos and Need Help?). On tablet/desktop, open at level 1 for categories
      ;(isMobile(global) && onUpdateActiveMenu(0)) || onUpdateActiveMenu(1)
      document.body.style.overflow = 'hidden'
    } else if (!menuToggled) {
      document.body.style.overflow = ''
    }
    return {
      menuToggled,
      previousMenu: 0, // Reset previous menu level stored
    }
  },
})
